import styled from "styled-components";
import { GoPlus } from "react-icons/go";

export const Background = styled.div`
  min-height: calc(100vh - 80px);
  display: flex;
  justify-content: center;
  padding: 0.5rem calc((90vw - 1200px) / 2);
  background-color: #0093e9;
  background-image: linear-gradient(0deg, #0093e9 0%, #99d4f7 50%, #ffffff 100%);
`;

export const Container = styled.div`
  width: 98%;
  height: fit-content;
  background: #fff;
  padding: 20px;
  display: flex;
  flex-direction: column;
  border-radius: 0.5rem;
  min-width: 289px;

  @media (max-width: 830px) {
    width: 90%;
  }
`;
export const BackgroundModal = styled.div`
  width: 100vw;
  height: 100vh;
  /* background: #fff; */
  display: flex;
  border-radius: 10px;
  position: fixed;
  top: 0;
  left: 0;
  align-items: center;
  justify-content: center;
  gap: 10px;

  div {
    flex-direction: row;
    flex-wrap: wrap;
  }
`;

export const Hr = styled.div`
  background-color: #0093e9;
  margin-top: 20px;
  margin-bottom: 20px;
  height: 0.2rem;
  width: 80%;
  justify-content: center;
  align-items: center;
  align-self: center;
`;

export const Row = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  div {
    display: flex;
    gap: 5px;
    align-items: center;
  }
  .selecionados {
    align-items: center;
    display: flex;
    flex-direction: column;
    margin: 0px;
    padding: 0 5px;
    gap: 0px;
    font-size: 12px;
    text-transform: uppercase;
    border: 1px solid #0093e9;
    
    .cargas {
      text-transform: capitalize;
      border: 0;
      display: flex;
      flex-direction: row;
      gap: 5px;
      padding: 5px;
    }
  }
`;

export const Barra = styled.div`
  display: flex;
  border: 1px solid #0093e9;
`;

export const Titulo = styled.h1`
  color: #0093e9;
  text-align: center;

  @media (max-width: 550px) {
    font-size: 28px;
  }
`;

export const Button = styled.button`
  margin-right: 5px;
  width: fit-content;
  height: fit-content;
  padding: 15px 20px;
  border-radius: 4px;
  background: #2b74e0;
  color: #fff;
  border: 2px;
  outline: none;
  cursor: pointer;
  font-weight: bold;
  font-size: 17px;
  text-decoration: none;
  text-align: center;
  transition: linear 0.2s;
  text-transform: capitalize;

  &:hover {
    background-color: #1563cf;
  }
`;

export const Inputs = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 5px;

  select {
    padding: 3px 7px;
    width: 250px;
    height: 45px;
    border-radius: 4px;
    margin-left: 5px;
    margin-right: 5px;
    font-size: 17px;
  }
  option {
    color: white;
    display: flex;
    text-align: center;
    align-items: center;
    background-color: #2b74e0;
    &:hover {
      background-color: #1563cf;
    }
  }

  input {
    padding: 3px 7px;
    width: 250px;
    height: 45px;
    border-radius: 4px;
    margin-left: 5px;
    margin-right: 5px;
    font-size: 17px;
  }
`;

export const Table = styled.div`
  margin-top: 15px;
  /* width: 99%; */
  overflow-x: auto;

  th,
  td {
    padding: 0 5px;
  }
  /* .id_carga {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    border: 1;
  } */

  .color {
    display: flex;
    padding: 10px 10px;
    width: 10px;
    height: 10px;
    border-radius: 100px;
    background-color: #6aa84f;
  }
`;

export const AddIcon = styled(GoPlus)``;

export const Checkbox = styled.div`
  width: 1.3rem;
  height: 1.3rem;
  border: 2px solid var(--red-color);
  border: 2px solid black;
  border-radius: 0.2rem;
  margin: auto;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
`;
